function get(params) {
  return this.axios.get('/newsletters', { params })
}

function post(id, filters = {}) {
  return this.axios.post('/newsletters', { filters, id })
}

function batchDelete(id) {
  return this.axios.post('/newsletters/batch/delete', { id })
}

function batchActivate(id) {
  return this.axios.post('/newsletters/batch/activate', { id })
}

function batchDeactivate(id) {
  return this.axios.post('/newsletters/batch/deactivate', { id })
}

function itemDelete(id) {
  return this.axios.delete(`/newsletters/item/${id}`)
}

function itemActivate(id) {
  return this.axios.put(`/newsletters/item/${id}/activate`)
}

function itemDeactivate(id) {
  return this.axios.put(`/newsletters/item/${id}/deactivate`)
}

const newsletters = (axios) => ({
  axios,
  get,
  post,
  item: {
    axios,
    activate: itemActivate,
    deactivate: itemDeactivate,
    delete: itemDelete,
  },
  batch: {
    axios,
    activate: batchActivate,
    deactivate: batchDeactivate,
    delete: batchDelete,
  },
})

export default newsletters
